import type { LocalAttachment, LocalReport, OfflineOperation } from './types';

export function canCancelReportTransfer(op: OfflineOperation): boolean {
  return op.status === 'error' && ['report_create', 'report_update', 'report_submit'].includes(op.action);
}

// Cancel the whole rejected report group: otherwise dirty/wantsSubmit recreates it.
export function cancelReportTransfers(operations: OfflineOperation[], reports: LocalReport[], attachments: LocalAttachment[], ids: string[]) {
  const selected = operations.filter(op => ids.includes(op.operation_id));
  if (!selected.length || selected.some(op => !canCancelReportTransfer(op))) throw new Error('Nur fehlgeschlagene Berichtsübertragungen können verworfen werden.');
  const localIDs = new Set(selected.map(op => op.local_entity_id).filter(Boolean));
  const serverIDs = new Set(selected.map(op => Number(op.payload.report_id)).filter(Boolean));
  for (const report of reports) if (localIDs.has(report.local_id) || (report.report_id && serverIDs.has(report.report_id))) {
    localIDs.add(report.local_id);
    if (report.report_id) serverIDs.add(report.report_id);
  }
  const related = (op: OfflineOperation) => ids.includes(op.operation_id) || Boolean(op.local_entity_id && localIDs.has(op.local_entity_id)) || Boolean(Number(op.payload.report_id) && serverIDs.has(Number(op.payload.report_id)));
  const removed = operations.filter(related);
  if (removed.some(op => !canCancelReportTransfer(op))) throw new Error('Zu diesem Bericht gibt es noch nicht abgeschlossene Übertragungen. Bitte zuerst synchronisieren.');
  const reportRemoved = (report: LocalReport) => localIDs.has(report.local_id) || Boolean(report.report_id && serverIDs.has(report.report_id));
  const fileRemoved = (file: LocalAttachment) => localIDs.has(file.report_local_id) || Boolean(file.report_id && serverIDs.has(file.report_id));
  return {
    operations: operations.filter(op => !related(op)),
    reports: reports.filter(report => !reportRemoved(report)),
    attachments: attachments.filter(file => !fileRemoved(file)),
    archive: { operations: removed, reports: reports.filter(reportRemoved), attachments: attachments.filter(fileRemoved) },
  };
}
